import axios, {axiosPrivate} from '../../../libs/axios'
import {AuthModel, UserModel} from './_models'

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `cms/auth/login`
export const REGISTER_URL = `cms/auth/register`
export const REQUEST_PASSWORD_URL = `cms/auth/forgot_password`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

// export function getUserByToken(token: string) {
//   return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
//     api_token: token,
//   })
// }

export function getUserProfile(token: string) {
  return axios.get<{user: UserModel; permissions: any[]}>(`cms/auth/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function getSidebarMenus(axiosPrivate) {
  return axiosPrivate.get(`dashboard/menus`)
}
